import { getStore, resetUnreadCountInStore } from 'core_main/store';
import { importAndInitializePubNub } from 'core_main/helpers/vendors';
import { runListenersForOnUnreadCountChangeEvent } from 'core_main/pubnub/helpers';
import { getSession } from 'core_main/api/sessions';
import { ChatSessionsData } from 'core_main/api/sessions/types';
import { ReadMessage, MarkReadParameters } from './types';
import { validateMarkReadParams } from './helpers';

export const publishReadMessage = (session: ChatSessionsData) => {
  const { id } = session;
  const { channels } = session.attributes.pubnub.data;

  const convoMetaChannel = channels.find(
    (channel) => channel.type === 'meta-conversation',
  );

  return importAndInitializePubNub().then((module) => {
    const pubnub = module;

    if (typeof pubnub === 'object' && convoMetaChannel) {
      const readMessage: ReadMessage = {
        message: {
          eventType: 'read',
        },
        channel: convoMetaChannel.name,
      };

      pubnub.publish(readMessage).then(() => {
        resetUnreadCountInStore(id);
        runListenersForOnUnreadCountChangeEvent(id);
      });
    }
  });
};

export const markRead = (parameters: MarkReadParameters) => {
  const store = getStore();
  const { sessions } = store;
  const sessionId = parameters?.conversationId;

  try {
    const validateMarkReadParamsError = validateMarkReadParams(sessionId);

    if (validateMarkReadParamsError) {
      throw validateMarkReadParamsError;
    }

    const session = sessions[sessionId];

    if (!session) {
      return getSession(sessionId)
        .then((response) => {
          publishReadMessage(response.data);
        })
        .catch((error) => {
          console.error('Failed to mark message as read', error);
        });
    }

    return publishReadMessage(session);
  } catch (error) {
    console.error('Failed to mark message as read', error);
  }

  return undefined;
};
